import { ASSETS_URL, ReviewProduct, ReviewType, VideoReview } from '../../types';
import poster from '@/static/assets/reviews/AnnePaas_Pet/video.jpg';
import subs from '@/static/assets/reviews/AnnePaas_Pet/subs.vtt';

export const AnnePaas: VideoReview = {
  type: ReviewType.Video,
  product: [ReviewProduct.Pet, ReviewProduct.All],
  reviewerName: 'Anne',
  videoUrl: `${ASSETS_URL}/pet/AnnePass_Pet.webm`,
  posterUrl: poster,
  captionsUrl: subs,
};
